<template>
  <div>
    <div class="tw-font-bold tw-mb-2">
      Advanced: Override Security Weights
    </div>
    <button
      class="tw-bg-blue-500 tw-text-white tw-px-2 tw-py-1 tw-rounded"
      @click="addOverride"
    >
      + Add Override
    </button>
    <div
      v-for="(override, index) in checkupStore.overrides"
      :key="index"
      class="tw-mt-2 tw-flex tw-items-center"
    >
      <input
        v-model="override.symbol"
        class="tw-mr-2 tw-p-1 tw-border tw-rounded"
      >
      <input
        v-model.number="override.minWeight"
        type="number"
        min="0"
        max="100"
        step="0.001"
        class="tw-mr-2 tw-p-1 tw-border tw-rounded tw-w-20"
        placeholder="Min %"
      >
      <input
        v-model.number="override.maxWeight"
        type="number"
        min="0"
        max="100"
        step="0.001"
        class="tw-mr-2 tw-p-1 tw-border tw-rounded tw-w-20"
        placeholder="Max %"
      >
      <button
        class="tw-bg-red-500 tw-text-white tw-px-2 tw-py-1 tw-rounded"
        @click="removeOverride(index)"
      >
        Remove
      </button>
    </div>
    <hr>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
    ...mapStores(useCheckupStore),
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    addOverride() {
      this.checkupStore.overrides.push({ symbol: '', minWeight: null, maxWeight: null });
    },
    removeOverride(index) {
      this.checkupStore.overrides.splice(index, 1);
    },
  },
};
</script>


  <style scoped>

  </style>
